import { resolveConfidenceVisitorId } from "@helpers/confidenceVisitorId"
import { Confidence } from "@spotify-confidence/sdk"

export const CURRENT_CONFIDENCE_FLAG = "pd-paymentmethodsoptimization"

export const confidence = Confidence.create({
  clientSecret: import.meta.env.VITE_CONFIDENCE_CLIENT_SECRET as string,
  environment: "client",
  region: "eu",
  timeout: 1000,
})

// Set directly rather than through the SDK's visitorIdentity() tracker. That
// tracker re-read the cookie on every page load and minted a fresh uuid
// whenever it found none, so on the iOS in-app browsers that drop the cookie
// mid-document it produced a different randomisation unit per page view, which
// would quietly split any running test. resolveConfidenceVisitorId resolves one
// id per page load and prefers an existing one, so a returning visitor stays in
// the variant they were already served.
const visitorId = resolveConfidenceVisitorId()

if (visitorId) confidence.setContext({ visitor_id: visitorId })

export function getVariant(flag: { variant: string }) {
  const variantOverride = new URLSearchParams(window.location.search).get(
    "variant",
  )

  return variantOverride ?? flag.variant
}
